import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-side-menu-group-title',
  standalone: true,
  imports: [],
  templateUrl: './side-menu-group-title.component.html',
  styleUrl: './side-menu-group-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
// eslint-disable-next-line @tseslint/no-extraneous-class
export class SideMenuGroupTitleComponent {}
